import Vue from 'vue'
import Router from 'vue-router'
import Http from './service/http'

// import Login from './components/Login.vue'
const Login = () => import( /* webpackChunkName: "login_home_welcome" */ './components/Login.vue')

const register = () => import( /* webpackChunkName: "login_home_welcome" */ './components/register.vue')

const ForgetPassword = () => import( /* webpackChunkName: "Order_Report" */ './components/ForgetPassword.vue')

// import Home from './components/Home.vue'
const Home = () => import( /* webpackChunkName: "login_home_welcome" */ './components/Home.vue')

const vpthome = () => import( /* webpackChunkName: "login_home_welcome" */ './components/vpthome.vue')

// import Welcome from './components/Welcome.vue'
const Welcome = () => import( /* webpackChunkName: "login_home_welcome" */ './components/Welcome.vue')

// import Users from './components/user/Users.vue'
const user = () => import( /* webpackChunkName: "Order_Report" */ './components/user/user.vue')

const UnitManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/user/UnitManagement.vue')

const SpManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/user/SpManagement.vue')

const up = () => import( /* webpackChunkName: "Order_Report" */ './components/user/up.vue')

const StudentManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/user/StudentManagement.vue')

const ClassManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/user/ClassManagement.vue')

const StaffManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/user/StaffManagement.vue')

const userAccount = () => import( /* webpackChunkName: "Order_Report" */ './components/user/userAccount.vue')

const department = () => import( /* webpackChunkName: "Order_Report" */ './components/user/department.vue')

const teamManage = () => import( /* webpackChunkName: "Order_Report" */ './components/user/teamManage.vue')

const DisManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/user/DisManagement.vue')

const sheet = () => import( /* webpackChunkName: "Order_Report" */ './components/sheet.vue')

const file = () => import( /* webpackChunkName: "Order_Report" */ './components/file')

const demonstrator = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/demonstrator.vue')

const onlineConsultation = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/onlineConsultation.vue')

const caselist = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/caselist.vue')

const vpt = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/vpt.vue')

const LearningMaterials = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/LearningMaterials.vue')

const systemMenu = () => import( /* webpackChunkName: "Order_Report" */ './components/user/systemMenu.vue')

const systemMenu1 = () => import( /* webpackChunkName: "Order_Report" */ './components/user/systemMenu1.vue')

const customUnitMenu = () => import( /* webpackChunkName: "Order_Report" */ './components/user/customUnitMenu.vue')

const examinationManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/examination/examinationManagement.vue')

const GenerateTest = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/examination/GenerateTest.vue')

const markExamination = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/mark/markExamination.vue')

const readAppraise = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/mark/readAppraise.vue')

const groupManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/groupManagement.vue')

const caseManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/user/caseManagement.vue')

const addCaseManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/user/addCaseManagement.vue')

const scoringTable = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/scoringTable.vue')

const Temporarily = () => import( /* webpackChunkName: "Order_Report" */ './components/Temporarily.vue')

const statisticalQuery = () => import( /* webpackChunkName: "Order_Report" */ './components/statistical/statisticalQuery.vue')

const testTRtc = () => import( /* webpackChunkName: "Order_Report" */ './components/trtc/index.vue')

const viewReport = () => import( /* webpackChunkName: "Order_Report" */ './components/statistical/viewReport.vue')

const GradingRecords = () => import( /* webpackChunkName: "Order_Report" */ './components/GradingRecords.vue')

const myExam = () => import( /* webpackChunkName: "Order_Report" */ './components/student/myExam.vue')

const toBeTested = () => import( /* webpackChunkName: "Order_Report" */ './components/student/toBeTested.vue')

const detailsOnline = () => import( /* webpackChunkName: "Order_Report" */ './components/student/detailsOnline.vue')

const startTheExam = () => import( /* webpackChunkName: "Order_Report" */ './components/student/startTheExam.vue')

const spExamination = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spExamination.vue')

const scoringDetails = () => import( /* webpackChunkName: "Order_Report" */ './components/student/scoringDetails.vue')

const fileManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/fileManagement.vue')

const resources = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/resources.vue')

const learningResource = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/learningResource.vue')

const fileDetails = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/fileDetails.vue')

const message = () => import( /* webpackChunkName: "Order_Report" */ './components/user/message.vue')

const roleManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/role/roleManagement.vue')

const Input_num = () => import( /* webpackChunkName: "Order_Report" */ './components/Input_num.vue')

const bookingManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/bookingManagement.vue')

const weekly = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/weekly.vue')

const StudentsTra = () => import( /* webpackChunkName: "Order_Report" */ './components/student/StudentsTra.vue')

const spTra = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spTra.vue')

const spDetails = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spDetails.vue')

const Myreservation = () => import( /* webpackChunkName: "Order_Report" */ './components/user/Myreservation.vue')

const studentsReport = () => import( /* webpackChunkName: "Order_Report" */ './components/student/studentsReport.vue')

const unitExamine = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/unitExamine.vue')

const AuditBooking = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/AuditBooking.vue')

const train = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/train.vue')

const train1 = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/train1.vue')

const statistic = () => import( /* webpackChunkName: "Order_Report" */ './components/user/statistic.vue')

const codetaskList = () => import( /* webpackChunkName: "Order_Report" */ './components/code/codetaskList.vue')

const setgroup = () => import( /* webpackChunkName: "Order_Report" */ './components/code/setgroup.vue')

const setteacher = () => import( /* webpackChunkName: "Order_Report" */ './components/code/setteacher.vue')

const codestudent = () => import( /* webpackChunkName: "Order_Report" */ './components/code/codestudent.vue')

const coderelease = () => import( /* webpackChunkName: "Order_Report" */ './components/code/coderelease.vue')

const codereport = () => import( /* webpackChunkName: "Order_Report" */ './components/code/codereport.vue')

const Addtemplate = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/Addtemplate.vue')

const ArotaryDetails = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/ArotaryDetails.vue')

const evaluate = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/evaluate.vue')

const EvaTemplate = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/EvaTemplate.vue')

const grade = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/grade.vue')

const implementation = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/implementation.vue')

const learningTasks = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/learningTasks.vue')

const myMission = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/myMission.vue')

const report = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/report.vue')

const rotaryDetails = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/rotaryDetails.vue')

const setPlan = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/setPlan.vue')

const setRotary = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/setRotary.vue')

const BannerManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/user/BannerManagement.vue')

const commonResource = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/commonResource.vue')

const PrivateResources = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/PrivateResources.vue')

const sptraining = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/sptraining.vue')

const spRecruitment = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spRecruitment.vue')

const spteatraining = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spteatraining.vue')

const spapply = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spapply.vue')

const supervisor = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/supervisor.vue')

const ensupervisor = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/ensupervisor.vue')

const Supervisevideo = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/Supervisevideo.vue')

const supervisorsheet = () => import( /* webpackChunkName: "Order_Report" */ './components/supervisorsheet.vue')

const RoomManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/offline/RoomManagement.vue')

const OfflineTest = () => import( /* webpackChunkName: "Order_Report" */ './components/offline/OfflineTest.vue')

const OfflineSetting = () => import( /* webpackChunkName: "Order_Report" */ './components/offline/OfflineSetting.vue')

const OfflineviewReport = () => import( /* webpackChunkName: "Order_Report" */ './components/offline/OfflineviewReport.vue')

const BuildingManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/siteManagement/BuildingManagement.vue')

const SiteMaintenance = () => import( /* webpackChunkName: "Order_Report" */ './components/siteManagement/SiteMaintenance.vue')

const CategoryManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/CategoryManagement.vue')

const ItemManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/ItemManagement.vue')

const InventoryManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/InventoryManagement.vue')

const UniMtanagement = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/UniMtanagement.vue')

const ItemAudit = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/ItemAudit.vue')

const Stateuse = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/Stateuse.vue')

const CalendarSettings = () => import( /* webpackChunkName: "Order_Report" */ './components/trainingmanagement/CalendarSettings.vue')

const addKalendar = () => import( /* webpackChunkName: "Order_Report" */ './components/trainingmanagement/addKalendar.vue')

const LaboratoryUse = () => import( /* webpackChunkName: "Order_Report" */ './components/trainingmanagement/LaboratoryUse.vue')

const LaboratoryAudit = () => import( /* webpackChunkName: "Order_Report" */ './components/trainingmanagement/LaboratoryAudit.vue')

const lookmake = () => import( /* webpackChunkName: "Order_Report" */ './components/trainingmanagement/lookmake.vue')

const siteUseRecord = () => import( /* webpackChunkName: "Order_Report" */ './components/siteManagement/siteUseRecord.vue')

const evaluationReport = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/evaluationReport.vue')

const siteUseDetail = () => import( /* webpackChunkName: "Order_Report" */ './components/siteManagement/siteUseDetail.vue')

const siteUseSchedule = () => import( /* webpackChunkName: "Order_Report" */ './components/siteManagement/siteUseSchedule.vue')

const manageCourse = () => import( /* webpackChunkName: "Order_Report" */ './components/teachingManagement/manageCourse.vue')

const manageCourseContent = () => import( /* webpackChunkName: "Order_Report" */ './components/teachingManagement/manageCourseContent.vue')

const manageTerm = () => import( /* webpackChunkName: "Order_Report" */ './components/teachingManagement/manageTerm.vue')

const morestatistic = () => import( /* webpackChunkName: "Order_Report" */ './components/user/morestatistic.vue')

const studentrecords = () => import( /* webpackChunkName: "Order_Report" */ './components/user/studentrecords.vue')

const StudentsStatistical = () => import( /* webpackChunkName: "Order_Report" */ './components/user/StudentsStatistical.vue')

const clinicalTeacher = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/clinicalTeacher.vue')

const TeachingStudents = () => import( /* webpackChunkName: "Order_Report" */ './components/pjWeb/TeachingStudents.vue')

const EtsManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/osecManagementBasic/EtsManagement.vue')
const cameraManagement = () => import( /* webpackChunkName: "Order_Report" */ './views/osce/cameraManagement/index.vue')

const ExaminationItemSetting = () => import( /* webpackChunkName: "Order_Report" */ './components/osecManagementBasic/ExaminationItemSetting.vue')

const deviceManager = () => import( /* webpackChunkName: "Order_Report" */ './components/osecManagementBasic/deviceManager.vue')

const SiteManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/osecManagementBasic/SiteManagement.vue')

const labelManage = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/labelManage.vue')

const questionTypeManage = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/questionTypeManage.vue')

const qlist = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/qlist.vue')

const aiqa = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/aiqa.vue')

const importpaper = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/importpaper.vue')

const newqdanxuan = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/newqdanxuan.vue')

const newqduoxuan = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/newqduoxuan.vue')

const newqpanduan = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/newqpanduan.vue')

const newqcaozuo = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/newqcaozuo.vue')

const newqzuhe = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/newqzuhe.vue')

const newqwenda = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/newqwenda.vue')

const newqtiankong = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/newqtiankong.vue')

const publicqlist = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/publicqlist.vue')

const testpaperManage = () => import( /* webpackChunkName: "Order_Report" */ './components/papermanagement/testpaperManage.vue')

const testpaper_addtheory = () => import( /* webpackChunkName: "Order_Report" */ './components/papermanagement/testpaper_addtheory.vue')

const spevaluate = () => import( /* webpackChunkName: "Order_Report" */ './components/user/spevaluate.vue')

const spusagestatistics = () => import( /* webpackChunkName: "Order_Report" */  './components/user/spusagestatistics.vue')

const usagestatistics = () => import( /* webpackChunkName: "Order_Report" */ './components/user/usagestatistics.vue')

const spusagestatisticsdetail = () => import( /* webpackChunkName: "Order_Report" */  './components/user/spusagestatisticsdetail.vue')

const usagestatisticsdetails = () => import( /* webpackChunkName: "Order_Report" */ './components/user/usagestatisticsdetails.vue')

const testpaper_addoperate = () => import( /* webpackChunkName: "Order_Report" */ './components/papermanagement/testpaper_addoperate.vue')

const testpaper_checktheory = () => import( /* webpackChunkName: "Order_Report" */ './components/papermanagement/testpaper_checktheory.vue')

const testpaper_checkoperate = () => import( /* webpackChunkName: "Order_Report" */ './components/papermanagement/testpaper_checkoperate.vue')

const testList = () => import( /* webpackChunkName: "Order_Report" */ './components/osceadministration/testList.vue')

const examarrangement = () => import( /* webpackChunkName: "Order_Report" */ './components/osceadministration/examarrangement.vue')

const examarrangementedit = () => import( /* webpackChunkName: "Order_Report" */ './components/osceadministration/examarrangementedit.vue')

const examineeregister = () => import( /* webpackChunkName: "Order_Report" */ './components/osceadministration/examineeregister.vue')

const clinicalDiagnosis = () => import( /* webpackChunkName: "Order_Report" */ './components/Clinical/clinicalDiagnosis.vue')

const clinicallist = () => import( /* webpackChunkName: "Order_Report" */ './components/Clinical/clinicallist.vue')

const masterstation = () => import( /* webpackChunkName: "Order_Report" */ './components/osceadministration/masterstation.vue')

const oscereport = () => import( /* webpackChunkName: "Order_Report" */ './components/osceadministration/oscereport.vue')

const coursePlan = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/coursePlan.vue')

const official = () => import( /* webpackChunkName: "Order_Report" */ './components/official.vue')

const doorControl = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/doorControl.vue')

const Openrecord = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/Openrecord.vue')

const surveyadd = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/surveyadd.vue')

const caseData = () => import( /* webpackChunkName: "Order_Report" */ './components/caseData.vue')

const Openrecordlist = () => import( /* webpackChunkName: "Order_Report" */ './components/ItemManagement/Openrecordlist.vue')

const teachermark = () => import( /* webpackChunkName: "Order_Report" */ './components/oscemark/teachermark.vue')

const markvideo = () => import( /* webpackChunkName: "Order_Report" */ './components/oscemark/markvideo.vue')

const consultationRecord = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/consultationRecord.vue')

const studentmark = () => import( /* webpackChunkName: "Order_Report" */ './components/oscemark/studentmark.vue')

const informationlist = () => import( /* webpackChunkName: "Order_Report" */ './components/website/informationlist.vue')

const addinformation = () => import( /* webpackChunkName: "Order_Report" */ './components/website/addinformation.vue')

const eventnotice = () => import( /* webpackChunkName: "Order_Report" */ './components/website/eventnotice.vue')

const addeventnotice = () => import( /* webpackChunkName: "Order_Report" */ './components/website/addeventnotice.vue')

const spappointment = () => import( /* webpackChunkName: "Order_Report" */ './components/website/spappointment.vue')

const coursemanagement = () => import( /* webpackChunkName: "Order_Report" */ './components/course/coursemanagement.vue')

const coursegeneralization = () => import( /* webpackChunkName: "Order_Report" */ './components/course/coursegeneralization.vue')

const chapterdetails = () => import( /* webpackChunkName: "Order_Report" */ './components/course/chapterdetails.vue')

const certificatemanagement = () => import( /* webpackChunkName: "Order_Report" */ './components/course/certificatemanagement.vue')

const certificatereview = () => import( /* webpackChunkName: "Order_Report" */ './components/course/certificatereview.vue')

const certificatedetails = () => import( /* webpackChunkName: "Order_Report" */ './components/course/certificatedetails.vue')

const Messagemanagement = () => import( /* webpackChunkName: "Order_Report" */ './components/course/Messagemanagement.vue')

const peerjobmanagement = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/peerjobmanagement.vue')

const peerjobdetails = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/peerjobdetails.vue')

const peerrecommend = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/peerrecommend.vue')

const ceshi = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/ceshi.vue')

const coursemanagement1 = () => import( /* webpackChunkName: "Order_Report" */ './components/course/coursemanagement1.vue')

const courseopening = () => import( /* webpackChunkName: "Order_Report" */ './components/course/courseopening.vue')

const reportingManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/square/reportingManagement.vue')

const hotManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/square/hotManagement.vue')

const cardManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/square/cardManagement.vue')

const cardDetail = () => import( /* webpackChunkName: "Order_Report" */ './components/square/cardDetail.vue')

const screenHome = () => import( /* webpackChunkName: "Order_Report" */ './components/screen/home.vue')

const screens = () => import( /* webpackChunkName: "Order_Report" */ './components/screen/screens.vue')

const screenTheme = () => import( /* webpackChunkName: "Order_Report" */ './components/screen/screenTheme.vue')

const screenThemeLib = () => import( /* webpackChunkName: "Order_Report" */ './components/screen/screenThemeLib.vue')

const course = () => import( /* webpackChunkName: "Order_Report" */ './components/screen/lib/screen12.vue')

const spNumbers = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spNumbers.vue')

const termCourseTeaClass = () => import( /* webpackChunkName: "Order_Report" */ './components/user/termCourseTeaClass.vue')

const evalScore = () => import( /* webpackChunkName: "Order_Report" */ './components/user/evalScore.vue')

const evalList = () => import( /* webpackChunkName: "Order_Report" */ './components/user/evalList.vue')

const evalDetail = () => import( /* webpackChunkName: "Order_Report" */ './components/user/evalDetail.vue')

const evalReport = () => import( /* webpackChunkName: "Order_Report" */ './components/user/evalReport.vue')

const bannerSp = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/banner.vue')

const recharge = () => import( /* webpackChunkName: "Order_Report" */ './components/order/recharge.vue')

const consumption = () => import( /* webpackChunkName: "Order_Report" */ './components/order/consumption.vue')

const aftersale = () => import( /* webpackChunkName: "Order_Report" */ './components/order/aftersale.vue')

const spscreen = () => import( /* webpackChunkName: "Order_Report" */ './components/teacher/spscreen.vue')

const personStu = () => import( /* webpackChunkName: "Order_Report" */ './components/user/personStu.vue')

const inviteList = () => import( /* webpackChunkName: "Order_Report" */ './components/user/inviteList.vue')

const live = () => import( /* webpackChunkName: "Order_Report" */ './components/user/live.vue')

const standardName = () => import( /* webpackChunkName: "Order_Report" */ './components/resoues/standardName.vue')

const menuGroup = () => import( /* webpackChunkName: "Order_Report" */ './components/user/menuGroup.vue')

const topicType = () => import( /* webpackChunkName: "Order_Report" */ './components/square/topicType.vue')

const setlab = () => import( /* webpackChunkName: "Order_Report" */ './components/user/setlab.vue')

const expertManage = () => import( /* webpackChunkName: "Order_Report" */ './components/user/expertManage.vue')

const spTask = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spTask.vue')

const spExam = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spExam.vue')

const vptHis = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/vptHis.vue')

const virtualpatient = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/virtualpatient.vue')

const spreport = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spreport.vue')

const spreportStu = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spreportStu.vue')

const spTeaReport = () => import( /* webpackChunkName: "Order_Report" */ './components/sp/spTeaReport.vue')

const subManagement = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/subManagement.vue')

const questionTypeSingle = () => import( /* webpackChunkName: "Order_Report" */ './components/testbaseManagement/questionTypeSingle.vue')

const paperMode = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/paperMode.vue')

const examCreate = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/examCreate.vue')

const examEdit = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/examEdit.vue')

const examMonitoring = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/examMonitoring.vue')

const examMonitor = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/examMonitor.vue')

const examCorrect = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/examCorrect.vue')

const examCorrecting = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/examCorrecting.vue')

const examStatic = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/examStatic.vue')

const examDetail = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/examDetail.vue')

const examReport = () => import( /* webpackChunkName: "Order_Report" */'./components/papermanagement/examReport.vue')

const trainManagement = () => import( /* webpackChunkName: "Order_Report" */'./components/train/trainManagement.vue')

const trainStu = () => import( /* webpackChunkName: "Order_Report" */'./components/train/trainStu.vue')

const teachPlanManagement = () => import( /* webpackChunkName: "Order_Report" */'./components/teachPlan/teachPlanManagement.vue')

const trainAdd = () => import( /* webpackChunkName: "Order_Report" */'./components/train/trainAdd.vue')

const speakout = () => import( /* webpackChunkName: "Order_Report" */'./components/user/speakout.vue')

const trainsign = () => import( /* webpackChunkName: "Order_Report" */'./components/train/trainsign.vue')

const trainpaper = () => import( /* webpackChunkName: "Order_Report" */'./components/train/trainPaper.vue')

const groupTrain = () => import( /* webpackChunkName: "Order_Report" */'./components/train/groupTrain.vue')

const trainPub = () => import( /* webpackChunkName: "Order_Report" */'./components/train/trainPub.vue')

const studentProfile = () => import( /* webpackChunkName: "Order_Report" */ './components/train/studentProfile.vue')

const trainReport = () => import( /* webpackChunkName: "Order_Report" */ './components/train/trainReport.vue')

const speakerStatics = () => import( /* webpackChunkName: "Order_Report" */ './components/train/speakerStatics.vue')

const deptMonthStatistic = ()=>import('./views/statistics/deptMonth/index.vue')

const trainRecord = () => import( /* webpackChunkName: "Order_Report" */ './components/train/trainRecord.vue')

const outSpeaker = () => import( /* webpackChunkName: "Order_Report" */ './components/train/outSpeaker.vue')

const livedetail = () => import( /* webpackChunkName: "Order_Report" */ './components/train/livedetail.vue')

const liveing = () => import( /* webpackChunkName: "Order_Report" */ './components/train/liveing.vue')

const liveplay = () => import( /* webpackChunkName: "Order_Report" */ './components/train/liveplay.vue')

const internTrain = () => import( /* webpackChunkName: "Order_Report" */ './components/train/internTrain.vue')

const trainLive = () => import( /* webpackChunkName: "Order_Report" */ './components/train/trainLive.vue')

const teaEvel = () => import( /* webpackChunkName: "Order_Report" */ './components/train/teaEvel.vue')

const allEvel = () => import( /* webpackChunkName: "Order_Report" */ './components/train/allEvel.vue')

const evelReport = () => import( /* webpackChunkName: "Order_Report" */ './components/train/evelReport.vue')

const stuEvel = () => import( /* webpackChunkName: "Order_Report" */ './components/train/stuEvel.vue')

const teaEvellist = () => import( /* webpackChunkName: "Order_Report" */ './components/train/teaEvellist.vue')

const stuEvellist = () => import( /* webpackChunkName: "Order_Report" */ './components/train/stuEvellist.vue')

const stuApprove = () => import( /* webpackChunkName: "Order_Report" */ './components/train/stuApprove.vue')

const stuActivity = () => import( /* webpackChunkName: "Order_Report" */ './components/train/stuActivity.vue')

const teachPlan = () => import( /* webpackChunkName: "Order_Report" */ './components/train/teachPlan.vue')

const teachPlanManage = () => import( /* webpackChunkName: "Order_Report" */ './components/train/teachPlanManage.vue')

const stuApproveManage = () => import( /* webpackChunkName: "Order_Report" */ './components/train/stuApproveManage.vue')

const spSalary = () => import( /* webpackChunkName: "Order_Report" */ './components/user/spSalary.vue')

const spOfflineSalary = () => import( /* webpackChunkName: "Order_Report" */ './components/user/spOfflineSalary.vue')

const xnfz = () => import( /* webpackChunkName: "Order_Report" */ './components/xnfz/xnfz.vue')

const virtualScore = () => import( /* webpackChunkName: "Order_Report" */ './components/xnfz/virtualScore.vue')

const scoreDetail = () => import( /* webpackChunkName: "Order_Report" */ './components/xnfz/scoreDetail.vue')

const NeiJiangHome = () => import( /* webpackChunkName: "Order_Report" */ './views/neiJiangHome/index.vue')

Vue.use(Router)


const router = new Router({
  routes: [{
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/register',
    component: register
  },
  {
    path: '/ForgetPassword',
    component: ForgetPassword
  },
  {
    path: '/testTRtc',
    component: testTRtc
  },
  {
    path: '/official',
    component: official
  },
  {
    path: '/screenHome',
    component: screenHome
  },
  {
    path: '/screens',
    component: screens
  },
  {
    path: '/course',
    component: course
  },
  {
    path: '/home',
    component: Home,
    redirect: ()=>{
      let UserAccount = JSON.parse(window.sessionStorage.getItem('userAccount'))
      // 根据cpyId进行不同的重定向
      if (!UserAccount) {
        return '/welcome' // 默认重定向到欢迎页
      }
      switch(UserAccount.cpyId) {
        case 213: // 内江
          return '/neiJiangHome'
        default:
          return '/welcome'
      }
    },
    meta: {
      title: '首页'
    },
    children: [
    {
      path: '/neiJiangHome',
      component: NeiJiangHome,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/welcome',
      component: Welcome,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/user',
      component: user,
      meta: {
        title: '个人资料'
      }
    },
    {
      path: '/UnitManagement',
      component: UnitManagement,
      meta: {
        title: '单位管理'
      }
    },
    {
      path: '/SpManagement',
      component: SpManagement,
      meta: {
        title: 'SP管理'
      }
    },
    {
      path: '/up',
      component: up,
      meta: {
        title: '测试'
      }
    },
    {
      path: '/StudentManagement',
      component: StudentManagement,
      meta: {
        title: '学生管理'
      }
    },
    {
      path: '/speakout',
      component: speakout,
      meta: {
        title: '院外主讲人'
      }
    },
    {
      path: '/ClassManagement',
      component: ClassManagement,
      meta: {
        title: '专业管理'
      }
    },
    {
      path: '/StaffManagement',
      component: StaffManagement,
      meta: {
        title: '用户管理'
      }
    },
    {
      path: '/studentProfile',
      component: studentProfile,
      meta: {
        title: '学员培训档案'
      }
    },
    {
      path: '/trainReport',
      component: trainReport,
      meta: {
        title: '培训统计'
      }
    },
    {
      path: '/speakerStatics',
      component: speakerStatics,
      meta: {
        title: '讲师授课统计'
      }
    },
    {
      path:'/deptMonthStatistic',
      component: deptMonthStatistic,
      meta: {
        title: '科室按月统计'
      }
    },
    {
      path: '/trainRecord',
      component: trainRecord,
      meta: {
        title: '培训档案'
      }
    },
    {
      path: '/outSpeaker',
      component: outSpeaker,
      meta: {
        title: '院外主讲人'
      }
    },
    {
      path: '/livedetail',
      component: livedetail,
      meta: {
        title: '直播'
      }
    },
    {
      path: '/liveing',
      component: liveing,
      meta: {
        title: '直播'
      }
    },
    {
      path: '/liveplay',
      component: liveplay,
      meta: {
        title: '直播回放'
      }
    },
    {
      path: '/internTrain',
      component: internTrain,
      meta: {
        title: '实习生培训'
      }
    },
    {
      path: '/teaEvel',
      component: teaEvel,
      meta: {
        title: '带教老师评价'
      }
    },
    {
      path: '/allEvel',
      component: allEvel,
      meta: {
        title: '综合评价'
      }
    },
    {
      path: '/evelReport',
      component: evelReport,
      meta: {
        title: '综合评价报告'
      }
    },
    {
      path: '/teaEvellist',
      component: teaEvellist,
      meta: {
        title: '带教老师评价列表'
      }
    },
    {
      path: '/stuApprove',
      component: stuApprove,
      meta: {
        title: '实习生请销假'
      }
    },
    {
      path: '/stuActivity',
      component: stuActivity,
      meta: {
        title: '实习生志愿活动'
      }
    },
    {
      path: '/teachPlan',
      component: teachPlan,
      meta: {
        title: '教学计划'
      }
    },
    {
      path: '/teachPlanManage',
      component: teachPlanManage,
      meta: {
        title: '教学计划管理'
      }
    },
    {
      path: '/stuApproveManage',
      component: stuApproveManage,
      meta: {
        title: '实习生请销假'
      }
    },
    {
      path: '/stuEvel',
      component: stuEvel,
      meta: {
        title: '实习生评价'
      }
    },
    {
      path: '/stuEvellist',
      component: stuEvellist,
      meta: {
        title: '实习生评价列表'
      }
    },
    {
      path: '/trainLive',
      component: trainLive,
      meta: {
        title: '直播培训'
      }
    },
    {
      path: '/userAccount',
      component: userAccount,
      meta: {
        title: '教职工管理'
      }
    },
    {
      path: '/department',
      component: department,
      meta: {
        title: '部门管理'
      }
    },
    {
      path: '/teamManage',
      component: teamManage,
      meta: {
        title: '专科小组管理'
      }
    },
    {
      path: '/DisManagement',
      component: DisManagement,
      meta: {
        title: '学科管理'
      }
    },
    {
      path: '/detailsOnline',
      component: detailsOnline,
      meta: {
        title: '在线问诊详情'
      }
    },
    {
      path: '/onlineConsultation',
      component: onlineConsultation,
      meta: {
        title: '在线问诊'
      }
    },
    {
      path: '/caselist',
      component: caselist,
      meta: {
        title: '精品病例'
      }
    },
    {
      path: '/vpthome',
      component: vpthome,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/vpt',
      component: vpt,
      meta: {
        title: '虚拟病人'
      }
    },
    {
      path: '/LearningMaterials',
      component: LearningMaterials,
      meta: {
        title: 'sp预约'
      }
    },
    {
      path: '/sheet',
      component: sheet
    },
    {
      path: '/file',
      component: file
    },
    {
      path: '/examinationManagement',
      component: examinationManagement,
      meta: {
        title: '考试管理'
      }
    },
    {
      path: '/GenerateTest',
      component: GenerateTest,
      meta: {
        title: '考试管理'
      }
    },
    {
      path: '/markExamination',
      component: markExamination,
      meta: {
        title: '我的评卷'
      }
    },
    {
      path: '/readAppraise',
      component: readAppraise,
      meta: {
        title: '我的评卷'
      }
    },
    {
      path: '/systemMenu',
      component: systemMenu,
      meta: {
        title: '系统菜单'
      }
    },
    {
      path: '/systemMenu1',
      component: systemMenu1,
      meta: {
        title: '系统菜单'
      }
    },
    {
      path: '/customUnitMenu',
      component: customUnitMenu,
      meta: {
        title: '自定义菜单'
      }
    },
    {
      path: '/groupManagement',
      component: groupManagement,
      meta: {
        title: '群组管理'
      }
    },
    {
      path: '/caseManagement',
      component: caseManagement,
      meta: {
        title: '病例管理'
      }
    },
    {
      path: '/addCaseManagement',
      component: addCaseManagement,
      meta: {
        title: '新增病例'
      }
    },
    {
      path: '/scoringTable',
      component: scoringTable,
      meta: {
        title: '评分表管理'
      }
    },
    {
      path: '/standardName',
      component: standardName,
      meta: {
        title: '标准评分表名称管理'
      }
    },
    {
      path: '/Temporarily',
      component: Temporarily
    },
    {
      path: '/statisticalQuery',
      component: statisticalQuery,
      meta: {
        title: '考试报告'
      }
    },
    {
      path: '/viewReport',
      component: viewReport,
      meta: {
        title: '查看报告'
      }
    },
    {
      path: '/GradingRecords',
      component: GradingRecords,
      meta: {
        title: '视频'
      }
    },
    {
      path: '/myExam',
      component: myExam,
      meta: {
        title: '我的考试'
      }
    },
    {
      path: '/toBeTested',
      component: toBeTested,
      meta: {
        title: '实时评分'
      }
    },
    {
      path: '/startTheExam',
      component: startTheExam,
      meta: {
        title: '开始考试'
      }
    },
    {
      path: '/spExamination',
      component: spExamination,
      meta: {
        title: '我的评卷'
      }
    },
    {
      path: '/virtualpatient',
      component: virtualpatient,
      meta: {
        title: 'AI问诊'
      }
    },
    {
      path: '/scoringDetails',
      component: scoringDetails,
      meta: {
        title: '评分详情'
      }
    },
    {
      path: '/fileManagement',
      component: fileManagement,
      meta: {
        title: '文件管理'
      }
    },
    {
      path: '/resources',
      component: resources,
      meta: {
        title: '资源库'
      }
    },
    {
      path: '/learningResource',
      component: learningResource,
      meta: {
        title: '学习资源'
      }
    },
    {
      path: '/fileDetails',
      component: fileDetails,
      meta: {
        title: '资源详情'
      }
    },
    {
      path: '/message',
      component: message,
      meta: {
        title: '消息通知'
      }
    },
    {
      path: '/roleManagement',
      component: roleManagement,
      meta: {
        title: '角色管理'
      }
    },
    {
      path: '/Input_num',
      component: Input_num,
      meta: {
        title: '计时'
      }
    },
    {
      path: '/bookingManagement',
      component: bookingManagement,
      meta: {
        title: '预约管理'
      }
    },
    {
      path: '/weekly',
      component: weekly,
      meta: {
        title: '工作日历'
      }
    },
    {
      path: '/StudentsTra',
      component: StudentsTra,
      meta: {
        title: '在线问诊'
      }
    },
    {
      path: '/spTra',
      component: spTra,
      meta: {
        title: '在线问诊'
      }
    },
    {
      path: '/demonstrator',
      component: demonstrator,
      meta: {
        title: '在线问诊详情'
      }
    },
    {
      path: '/spDetails',
      component: spDetails,
      meta: {
        title: 'sp详情'
      }
    },
    {
      path: '/Myreservation',
      component: Myreservation,
      meta: {
        title: '我的预约'
      }
    },
    {
      path: '/studentsReport',
      component: studentsReport,
      meta: {
        title: '我的预约'
      }
    },
    {
      path: '/unitExamine',
      component: unitExamine,
      meta: {
        title: 'SP预约'
      }
    },
    {
      path: '/AuditBooking',
      component: AuditBooking,
      meta: {
        title: 'SP预约-审批'
      }
    },
    {
      path: '/train',
      component: train,
      meta: {
        title: '训练项管理'
      }
    },
    {
      path: '/train1',
      component: train1,
      meta: {
        title: '训练项管理'
      }
    },
    {
      path: '/statistic',
      component: statistic,
      meta: {
        title: '统计分析'
      }
    },
    {
      path: '/codetaskList',
      component: codetaskList,
      meta: {
        title: '任务管理'
      }
    },
    {
      path: '/coderelease',
      component: coderelease,
      meta: {
        title: '发布任务'
      }
    },
    {
      path: '/setgroup',
      component: setgroup,
      meta: {
        title: '设置群组'
      }
    },
    {
      path: '/setteacher',
      component: setteacher,
      meta: {
        title: '关联教师'
      }
    },
    {
      path: '/codestudent',
      component: codestudent,
      meta: {
        title: '学生列表'
      }
    },
    {
      path: '/codereport',
      component: codereport,
      meta: {
        title: '查看报告'
      }
    },
    {
      path: '/Addtemplate',
      component: Addtemplate,
      meta: {
        title: '新增模版'
      }
    },
    {
      path: '/ArotaryDetails',
      component: ArotaryDetails,
      meta: {
        title: '轮转详情'
      }
    },
    {
      path: '/evaluate',
      component: evaluate,
      meta: {
        title: '评价报告'
      }
    },
    {
      path: '/EvaTemplate',
      component: EvaTemplate,
      meta: {
        title: '评价模版'
      }
    },
    {
      path: '/grade',
      component: grade,
      meta: {
        title: '评分'
      }
    },
    {
      path: '/implementation',
      component: implementation,
      meta: {
        title: '实习计划管理'
      }
    },
    {
      path: '/learningTasks',
      component: learningTasks,
      meta: {
        title: '实习任务'
      }
    },
    {
      path: '/myMission',
      component: myMission,
      meta: {
        title: '我的任务'
      }
    },
    {
      path: '/report',
      component: report,
      meta: {
        title: '报告详情'
      }
    },
    {
      path: '/rotaryDetails',
      component: rotaryDetails,
      meta: {
        title: '轮转详情'
      }
    },
    {
      path: '/setPlan',
      component: setPlan,
      meta: {
        title: '实习计划'
      }
    },
    {
      path: '/setRotary',
      component: setRotary,
      meta: {
        title: '轮转设置'
      }
    },
    {
      path: '/BannerManagement',
      component: BannerManagement,
      meta: {
        title: 'banner管理'
      }
    },
    {
      path: '/commonResource',
      component: commonResource,
      meta: {
        title: '公共资源'
      }
    },
    {
      path: '/PrivateResources',
      component: PrivateResources,
      meta: {
        title: '我的资源'
      }
    },
    {
      path: '/sptraining',
      component: sptraining,
      meta: {
        title: 'SP培训计划'
      }
    },
    {
      path: '/spRecruitment',
      component: spRecruitment,
      meta: {
        title: 'SP招募通知'
      }
    },
    {
      path: '/spteatraining',
      component: spteatraining,
      meta: {
        title: 'SP师资培训通知'
      }
    },
    {
      path: '/spapply',
      component: spapply,
      meta: {
        title: 'SP培训计划'
      }
    },
    {
      path: '/supervisor',
      component: supervisor,
      meta: {
        title: '考试督导'
      }
    },
    {
      path: '/Supervisevideo',
      component: Supervisevideo,
      meta: {
        title: '我的评卷'
      }
    },
    {
      path: '/supervisorsheet',
      component: supervisorsheet,
      meta: {
        title: '我的评卷'
      }
    },
    {
      path: '/ensupervisor',
      component: ensupervisor,
      meta: {
        title: '问诊督导'
      }
    },
    {
      path: '/RoomManagement',
      component: RoomManagement,
      meta: {
        title: '房间管理'
      }
    },
    {
      path: '/OfflineTest',
      component: OfflineTest,
      meta: {
        title: '线下考试管理'
      }
    },
    {
      path: '/OfflineSetting',
      component: OfflineSetting,
      meta: {
        title: '创建考试'
      }
    },
    {
      path: '/OfflineviewReport',
      component: OfflineviewReport,
      meta: {
        title: '查看报告'
      }
    },
    {
      path: '/BuildingManagement',
      component: BuildingManagement,
      meta: {
        title: '楼栋管理'
      }
    },
    {
      path: '/SiteMaintenance',
      component: SiteMaintenance,
      meta: {
        title: '场地维护'
      }
    },
    {
      path: '/CategoryManagement',
      component: CategoryManagement,
      meta: {
        title: '物品类别管理'
      }
    },
    {
      path: '/ItemManagement',
      component: ItemManagement,
      meta: {
        title: '资产信息'
      }
    },
    {
      path: '/InventoryManagement',
      component: InventoryManagement,
      meta: {
        title: '库存管理'
      }
    },
    {
      path: '/UniMtanagement',
      component: UniMtanagement,
      meta: {
        title: '计量单位管理'
      }
    },
    {
      path: '/ItemAudit',
      component: ItemAudit,
      meta: {
        title: '物品使用审核'
      }
    },
    {
      path: '/Stateuse',
      component: Stateuse,
      meta: {
        title: '物品使用状态'
      }
    },
    {
      path: '/CalendarSettings',
      component: CalendarSettings,
      meta: {
        title: '开发日历设置'
      }
    },
    {
      path: '/addKalendar',
      component: addKalendar,
      meta: {
        title: '开发日历设置'
      }
    },
    {
      path: '/LaboratoryUse',
      component: LaboratoryUse,
      meta: {
        title: '实验室使用情况一览表'
      }
    },
    {
      path: '/LaboratoryAudit',
      component: LaboratoryAudit,
      meta: {
        title: '实验室预约审核'
      }
    },
    {
      path: '/lookmake',
      component: lookmake,
      meta: {
        title: '预约查询'
      }
    },
    {
      path: '/siteUseRecord',
      component: siteUseRecord,
      meta: {
        title: '场地使用记录'
      }
    },
    {
      path: '/evaluationReport',
      component: evaluationReport,
      meta: {
        title: '评价报告'
      }
    },
    {
      path: '/siteUseDetail',
      component: siteUseDetail,
      meta: {
        title: '使用详情'
      }
    },
    {
      path: '/siteUseSchedule',
      component: siteUseSchedule,
      meta: {
        title: '周日历'
      }
    },
    {
      path: '/manageCourse',
      component: manageCourse,
      meta: {
        title: '标准课程管理'
      }
    },
    {
      path: '/manageCourseContent',
      component: manageCourseContent,
      meta: {
        title: '课程内容'
      }
    },
    {
      path: '/manageTerm',
      component: manageTerm,
      meta: {
        title: '学期管理'
      }
    },
    {
      path: '/morestatistic',
      component: morestatistic,
      meta: {
        title: '统计分析'
      }
    },
    {
      path: '/studentrecords',
      component: studentrecords,
      meta: {
        title: '训练记录'
      }
    },
    {
      path: '/StudentsStatistical',
      component: StudentsStatistical,
      meta: {
        title: '学生统计'
      }
    },
    {
      path: '/clinicalTeacher',
      component: clinicalTeacher,
      meta: {
        title: '带教老师评价'
      }
    },
    {
      path: '/TeachingStudents',
      component: TeachingStudents,
      meta: {
        title: '评价报告'
      }
    },
    {
      path: '/EtsManagement',
      component: EtsManagement,//EtsManagement,
      meta: {
        title: '考区管理'
      }
    },
    {
      path:'/osce/cameraManagement',
      component: cameraManagement,
      meta: {
        title: '摄像头管理'
      }
    },
    {
      path: '/ExaminationItemSetting',
      component: ExaminationItemSetting,
      meta: {
        title: '考试项目设置'
      }
    },
    {
      path: '/deviceManager',
      component: deviceManager,
      meta: {
        title: '设备管理'
      }
    },
    {
      path: '/SiteManagement',
      component: SiteManagement,
      meta: {
        title: '考试场所管理'
      }
    },
    {
      path: '/labelManage',
      component: labelManage,
      meta: {
        title: '题目标签管理'
      }
    },
    {
      path: '/questionTypeManage',
      component: questionTypeManage,
      meta: {
        title: '题目类别管理'
      }
    },
    {
      path: '/questionTypeSingle',
      component: questionTypeSingle,
      meta: {
        title: '自定义类别'
      }
    },
    {
      path: '/qlist',
      component: qlist,
      meta: {
        title: '题库管理'
      }
    },
    {
      path: '/aiqa',
      component: aiqa,
      meta: {
        title: '导入题目'
      }
    },
    {
      path: '/importpaper',
      component: importpaper,
      meta: {
        title: '导入试卷'
      }
    },
    {
      path: '/subManagement',
      component: subManagement,
      meta: {
        title: '题目科目与模块'
      }
    },
    {
      path: '/newqdanxuan',
      component: newqdanxuan,
      meta: {
        title: '单选题'
      }

    },
    {
      path: '/newqduoxuan',
      component: newqduoxuan,
      meta: {
        title: '多选题'
      }
    },
    {
      path: '/newqpanduan',
      component: newqpanduan,
      meta: {
        title: '判断题'
      }
    },
    {
      path: '/newqcaozuo',
      component: newqcaozuo,
      meta: {
        title: '操作题'
      }
    },
    {
      path: '/newqzuhe',
      component: newqzuhe,
      meta: {
        title: '组合题'
      }
    },
    {
      path: '/newqwenda',
      component: newqwenda,
      meta: {
        title: '问答题'
      }
    },
    {
      path: '/newqtiankong',
      component: newqtiankong,
      meta: {
        title: '填空题'
      }
    },
    {
      path: '/publicqlist',
      component: publicqlist,
      meta: {
        title: '题目'
      }
    },
    {
      path: '/testpaperManage',
      component: testpaperManage,
      meta: {
        title: '试卷'
      }
    },
    {
      path: '/paperMode',
      component: paperMode,
      meta: {
        title: '组卷'
      }
    },
    {
      path: '/examCreate',
      component: examCreate,
      meta: {
        title: '考试列表'
      }
    },
    {
      path: '/examEdit',
      component: examEdit,
      meta: {
        title: '发布考试'
      }
    },
    {
      path: '/examMonitoring',
      component: examMonitoring,
      meta: {
        title: '考试监控'
      }
    },
    {
      path: '/examMonitor',
      component: examMonitor,
      meta: {
        title: '提前收卷'
      }
    },
    {
      path: '/examCorrect',
      component: examCorrect,
      meta: {
        title: '批改试卷'
      }
    },
    {
      path: '/examCorrecting',
      component: examCorrecting,
      meta: {
        title: '批改试卷'
      }
    },
    {
      path: '/examDetail',
      component: examDetail,
      meta: {
        title: '考试详情'
      }
    },
    {
      path: '/examReport',
      component: examReport,
      meta: {
        title: '成绩报告'
      }
    },
    {
      path: '/trainManagement',
      component: trainManagement,
      meta: {
        title: '培训管理'
      }
    },
    {
      path: '/trainsign',
      component: trainsign,
      meta: {
        title: '签到和测验'
      }
    },
    {
      path: '/trainpaper',
      component: trainpaper,
      meta: {
        title: '随堂测验'
      }
    },
    {
      path: '/groupTrain',
      component: groupTrain,
      meta: {
        title: '专科小组培训'
      }
    },
    {
      path: '/trainPub',
      component: trainPub,
      meta: {
        title: '已发布培训'
      }
    },
    {
      path: '/trainAdd',
      component: trainAdd,
      meta: {
        title: '新增培训'
      }
    },
    {
      path: '/teachPlanManagement',
      component: teachPlanManagement,
      meta: {
        title: '培训计划'
      }
    },
    {
      path: '/trainStu',
      component: trainStu,
      meta: {
        title: '学员统计'
      }
    },
    {
      path: '/examStatic',
      component: examStatic,
      meta: {
        title: '考试查询'
      }
    },
    {
      path: '/testpaper_addtheory',
      component: testpaper_addtheory,
      meta: {
        title: '新增试卷'
      }
    },
    {
      path: '/spevaluate',
      component: spevaluate,
      meta: {
        title: 'SP评价'
      }
    },
    {
      path: '/spusagestatistics',
      component: spusagestatistics,
      meta: {
        title: 'SP使用统计'
      }
    },
    {
      path: '/usagestatistics',
      component: usagestatistics,
      meta: {
        title: '使用统计'
      }
    },
    {
      path: '/spusagestatisticsdetail',
      component: spusagestatisticsdetail,
      meta: {
        title: '查看记录'
      }
    },
    {
      path: '/usagestatisticsdetails',
      component: usagestatisticsdetails,
      meta: {
        title: '查看记录'
      }
    },
    {
      path: '/testpaper_addoperate',
      component: testpaper_addoperate,
      meta: {
        title: '新增试卷'
      }
    },
    {
      path: '/testpaper_checktheory',
      component: testpaper_checktheory,
      meta: {
        title: '查看试卷'
      }
    },
    {
      path: '/testpaper_checkoperate',
      component: testpaper_checkoperate,
      meta: {
        title: '查看试卷'
      }
    },
    {
      path: '/testList',
      component: testList,
      meta: {
        title: '考试列表'
      }
    },
    {
      path: '/examarrangement',
      component: examarrangement,
      meta: {
        title: '考试管理'
      }
    },
    {
      path: '/examarrangementedit',
      component: examarrangementedit,
      meta: {
        title: '考试编辑'
      }
    },
    {
      path: '/examineeregister',
      component: examineeregister,
      meta: {
        title: '考试名册'
      }
    },
    {
      path: '/clinicalDiagnosis',
      component: clinicalDiagnosis,
      meta: {
        title: '病例信息'
      }
    },
    {
      path: '/clinicallist',
      component: clinicallist,
      meta: {
        title: '设备管理'
      }
    },
    {
      path: '/masterstation',
      component: masterstation,
      meta: {
        title: '中控台'
      }
    },
    {
      path: '/oscereport',
      component: oscereport,
      meta: {
        title: '考试报告'
      }
    },
    {
      path: '/coursePlan',
      component: coursePlan,
      meta: {
        title: '课表管理'
      }
    },
    {
      path: '/doorControl',
      component: doorControl,
      meta: {
        title: '门禁管理'
      }
    },
    {
      path: '/Openrecord',
      component: Openrecord,
      meta: {
        title: '开门记录'
      }
    },
    {
      path: '/surveyadd',
      component: surveyadd,
      meta: {
        title: '问卷调查'
      }
    },
    {
      path: '/caseData',
      component: caseData,
      meta: {
        title: '病例资料'
      }
    },
    {
      path: '/Openrecordlist',
      component: Openrecordlist,
      meta: {
        title: '问卷列表'
      }
    },
    {
      path: '/teachermark',
      component: teachermark,
      meta: {
        title: '我的评卷'
      }
    },
    {
      path: '/markvideo',
      component: markvideo,
      meta: {
        title: '无人执考'
      }
    },
    {
      path: '/consultationRecord',
      component: consultationRecord,
      meta: {
        title: '问诊记录'
      }
    },
    {
      path: '/studentmark',
      component: studentmark,
      meta: {
        title: '我的考试'
      }
    },
    {
      path: '/informationlist',
      component: informationlist,
      meta: {
        title: '资讯管理'
      }
    },
    {
      path: '/addinformation',
      component: addinformation,
      meta: {
        title: '资讯管理'
      }
    },
    {
      path: '/eventnotice',
      component: eventnotice,
      meta: {
        title: '活动通知'
      }
    },
    {
      path: '/addeventnotice',
      component: addeventnotice,
      meta: {
        title: '活动通知'
      }
    },
    {
      path: '/spappointment',
      component: spappointment,
      meta: {
        title: 'SP登记信息'
      }
    },
    {
      path: '/coursemanagement',
      component: coursemanagement,
      meta: {
        title: '课程管理'
      }
    },
    {
      path: '/coursegeneralization',
      component: coursegeneralization,
      meta: {
        title: '数据概览'
      }
    },
    {
      path: '/chapterdetails',
      component: chapterdetails,
      meta: {
        title: '查看习题'
      }
    },
    {
      path: '/certificatemanagement',
      component: certificatemanagement,
      meta: {
        title: '证书管理'
      }
    },
    {
      path: '/certificatereview',
      component: certificatereview,
      meta: {
        title: '证书审核'
      }
    },
    {
      path: '/certificatedetails',
      component: certificatedetails,
      meta: {
        title: '证书审核详情'
      }
    },
    {
      path: '/Messagemanagement',
      component: Messagemanagement,
      meta: {
        title: '消息管理'
      }
    },
    {
      path: '/peerjobmanagement',
      component: peerjobmanagement,
      meta: {
        title: '作业管理'
      }
    },
    {
      path: '/peerjobdetails',
      component: peerjobdetails,
      meta: {
        title: '作业详情'
      }
    },
    {
      path: '/ceshi',
      component: ceshi,
      meta: {
        title: '测试'
      }
    },
    {
      path: '/peerrecommend',
      component: peerrecommend,
      meta: {
        title: '同侪推荐'
      }
    },
    {
      path: '/coursemanagement1',
      component: coursemanagement1,
      meta: {
        title: '课程管理'
      }
    },
    {
      path: '/courseopening',
      component: courseopening,
      meta: {
        title: '课程开放'
      }
    },
    {
      path: '/reportingManagement',
      component: reportingManagement,
      meta: {
        title: '举报管理'
      }
    },
    {
      path: '/hotManagement',
      component: hotManagement,
      meta: {
        title: '热门管理'
      }
    },
    {
      path: '/topicType',
      component: topicType,
      meta: {
        title: '活动专区'
      }
    },
    {
      path: '/cardManagement',
      component: cardManagement,
      meta: {
        title: '帖子管理'
      }
    },
    {
      path: '/cardDetail',
      component: cardDetail,
      meta: {
        title: '帖子详情'
      }
    },
    {
      path: '/screenTheme',
      component: screenTheme,
      meta: {
        title: '大屏主题配置'
      }
    },
    {
      path: '/screenThemeLib',
      component: screenThemeLib,
      meta: {
        title: '主题库管理'
      }
    },
    {
      path: '/spNumbers',
      component: spNumbers,
      meta: {
        title: 'sp问诊次数设置'
      }
    },
    {
      path: '/termCourseTeaClass',
      component: termCourseTeaClass,
      meta: {
        title: '学期课程教师班级关联'
      }
    },
    {
      path: '/evalScore',
      component: evalScore,
      meta: {
        title: '评教得分统计'
      }
    },
    {
      path: '/evalList',
      component: evalList,
      meta: {
        title: '评教记录'
      }
    },
    {
      path: '/evalDetail',
      component: evalDetail,
      meta: {
        title: '评价详情'
      }
    },
    {
      path: '/evalReport',
      component: evalReport,
      meta: {
        title: '统计报告'
      }
    },
    {
      path: '/bannerSp',
      component: bannerSp,
      meta: {
        title: 'banner管理'
      }
    },
    {
      path: '/recharge',
      component: recharge,
      meta: {
        title: '充值订单'
      }
    },
    {
      path: '/consumption',
      component: consumption,
      meta: {
        title: '消费订单'
      }
    },
    {
      path: '/aftersale',
      component: aftersale,
      meta: {
        title: '售后订单'
      }
    },
    {
      path: '/spscreen',
      component: spscreen,
      meta: {
        title: '监控大屏'
      }
    },
    {
      path: '/inviteList',
      component: inviteList,
      meta: {
        title: '邀请人列表'
      }
    },
    {
      path: '/live',
      component: live,
      meta: {
        title: '直播讲座'
      }
    },
    {
      path: '/expertManage',
      component: expertManage,
      meta: {
        title: '专家管理'
      }
    },
    {
      path: '/spTask',
      component: spTask,
      meta: {
        title: '发布问诊任务'
      }
    },
    {
      path: '/spExam',
      component: spExam,
      meta: {
        title: '问诊考试'
      }
    },
    {
      path: '/vptHis',
      component: vptHis,
      meta: {
        title: '训练历史'
      }
    },
    {
      path: '/spreport',
      component: spreport,
      meta: {
        title: '学生任务报告'
      }
    },
    {
      path: '/spreportStu',
      component: spreportStu,
      meta: {
        title: '报告'
      }
    },
    {
      path: '/spTeaReport',
      component: spTeaReport,
      meta: {
        title: '统计报告'
      }
    },
    {
      path: '/personStu',
      component: personStu,
      meta: {
        title: '个人账户管理'
      }
    },
    {
      path: '/menuGroup',
      component: menuGroup,
      meta: {
        title: '菜单组管理'
      }
    },
    {
      path: '/setlab',
      component: setlab,
      meta: {
        title: '标签管理'
      }
    }, {
      path: '/spSalary',
      component: spSalary,
      meta: {
        title: '薪酬财务报账'
      }
    }, {
      path: '/spOfflineSalary',
      component: spOfflineSalary,
      meta: {
        title: '线下薪酬填报'
      }
    }, {
      path: '/xnfz',
      component: xnfz,
      meta: {
        title: '虚拟仿真'
      }
    }, {
      path: '/virtualScore',
      component: virtualScore,
      meta: {
        title: '查看成绩'
      }
    }, {
      path: '/scoreDetail',
      component: scoreDetail,
      meta: {
        title: '成绩详情'
      }
    }
    ]
  }
  ]
})

// 挂载路由导航守卫
router.beforeEach( async (to, from, next) => {
  // 统一设置浏览器标签页标题（路由 meta.title 优先，缺失则用默认标题）
  document.title = (to.meta && to.meta.title) ? to.meta.title : '医学沟通技能培训考核管理平台'
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数，表示放行
  //     next()  放行    next('/login')  强制跳转
  if (to.path === '/login' || to.path === '/register' || to.path === '/ForgetPassword' ||
    to.path === '/testTRtc' || to.path === '/official') return next()
  // 如果url里有账号密码，则自动进行登录
  if (to.query?.account && to.query?.password) {
    try {
      await autoLogin(to.query)
    } catch (error) {
      alert('自动登录失败:' + error)
      return next('/login')
    }
  }
  // 获取token
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/login?to=' + '111')
  //

  next()
  let user = JSON.parse(window.sessionStorage.getItem('userAccount'))
  let cpyId = user.cpyId
  let ridList = user.ridList
  let kjkManage = 0
  ridList.forEach((i) => {
    if (i == 44) {
      kjkManage = 1
    }
  })
  if (cpyId == 110) {
    if (to.path == '/StudentManagement') {
      if (kjkManage == 1) {
        to.meta.title = '学员管理';
      } else {
        to.meta.title = '实习生管理';
      }
    }
    if (to.path == '/StaffManagement') {
      to.meta.title = '职工管理';
    }
    if (to.path == '/implementation') {
      if (kjkManage == 1) {
        to.meta.title = '任务管理';
      }
    }
    if (to.path == '/internTrain') {
      if (kjkManage == 1) {
        to.meta.title = '培训活动';
      }
    }
  }
})
// http://localhost:8081/#/LearningMaterials?caseId=69&id=5&cpyId=35&account=202101&password=rruv202101
function  autoLogin(query){
  return new Promise( async (resolve,reject)=>{
    const { data: res } = await Http.loginAccount(query)
    if (res.data?.token) {
      window.sessionStorage.setItem('token', res.data.token)
      window.sessionStorage.setItem('userAccount', JSON.stringify(res.data.userAccount))
      window.localStorage.setItem('userAccount', JSON.stringify(res.data.userAccount))
      window.localStorage.setItem('userStorage', JSON.stringify(query))
      resolve()
    }else{
      reject(res.msg)
    }
  })

}


export default router
